import { render } from "./NotFound.vue?vue&type=template&id=4981590b&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=4981590b&scoped=true&lang=scss"

import exportComponent from "/usr/share/nginx/production/goodedition/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4981590b"]])

export default __exports__